import { Link } from "react-router-dom";

export function RuAbout() {
  return (
    <>
      <p className="fs-5">
        *Pro*TankiRating — форк сайта <a href="https://tankirating.org">TankiRating</a> под ProTanki.
        Данный сайт не имеет ничего общего с официальными ресурсами игры и является лишь фан-проектом.<br />
        В данный момент на портале открыта свободная регистрация.
      </p>
      <p className="fs-5">
        Главное предназначение этого портала — возможность просмотра игровых данных "в динамике".
        В отличии от <a href="https://pro-tanki.online/ru/ratings">официального сайта рейтингов</a>, на портале можно
        посмотреть игровую активность и эффективность пользователя за различные промежутки времени, а также
        наблюдать за их изменениями на различных графиках.
        <br />
      </p>
      <p className="fs-5">
        Просто зайди на <Link to="/">главную страницу</Link>, и изучай функциональность самостоятельно!
      </p>

      <p className="h3 mt-4">
        Структура портала
      </p>

      <ul className="ms-4">
        <li><span className="fs-5"><Link to="/">Главная страница</Link> — рейтинг зарегистрированных пользователей</span></li>
        <li><span className="fs-5"><Link to="/user/Fizzika">Профиль пользователя</Link> — информация о игроке</span></li>
        <li><span className="fs-5"><Link to="/trends">Тренды</Link> — статистика по всем игрокам-легендам</span></li>
        {/* <li><span className="fs-5"><Link to="/online">OnlineHub</Link> — график онлаена!!111 К сожалению, только архивные данные, спасибо альтернативе гамез</span></li> */}
      </ul>

      <p className="h3 mt-4">
        Контакты
      </p>
      <p className="fs-5">
        Если ты сменил никнейм, хочешь удалить/заморозить свой аккаунт на портале, ну или просто есть что сказать:
      </p>
      <ul className="ms-4">
        <li><span className="fs-5">Discord <b>pngdrift</b></span></li>
      </ul>

    </>
  )
}